import { render, staticRenderFns } from "./infoo.vue?vue&type=template&id=152084ff&"
import script from "./infoo.vue?vue&type=script&lang=js&"
export * from "./infoo.vue?vue&type=script&lang=js&"
import style0 from "./infoo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports